<template>
    <v-layout v-if="dialog" row justify-center>
        <v-dialog
        :value="dialog"
        @input="reset()"
        persistent
        scrollable
        max-width="50vw"
        >
            <v-card>
                <v-card-title class="px-4">
                <div class="title">{{$t('screener.affiliation.create.title')}}</div>
                <v-spacer></v-spacer>
                <v-btn
                    class="mx-0 px-0"
                    small
                    dark
                    icon
                    color="grey"
                    @click="reset()"
                >
                    <v-icon small>$vuetify.icons.rms_close</v-icon>
                </v-btn></v-card-title
                >
                <v-divider></v-divider>
                <v-card-text class="px-4" style="max-height: 80vh">
                    <AffiliationForm
                    :affiliation.sync="affiliation"
                    ref="affiliationForm">
                    </AffiliationForm>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="px-4 py-3">
                  <v-spacer></v-spacer>
                  <v-btn class="ml-0" dark color="grey" @click="reset()">{{
                    $t("rms.button.cancel")
                  }}</v-btn>
                  <v-btn
                    class="mr-0"
                    color="secondary"
                    @click.stop="create()"
                    :loading="loading"
                    :disabled="loading"
                    >{{ $t("rms.button.create") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import DEFINES from "@/defines"
import AffiliationForm from "@/components/affiliation/Form"

export default {
    name: "AffiliationCreate",
    props:{
        dialog:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            affiliation:{
                title:null,
                validity:DEFINES.AFFILIATION.DEFAULT_VALIDITY_IN_DAYS,
                revenue_percentage:null,
                reporting_email:null,
                reporting_interval:DEFINES.AFFILIATION.DEFAULT_REPORTING_INTERVAL,
                enabled:false
            },
            loading:false
        }
    },
    components:{
        AffiliationForm
    },
    methods:{
        reset() {
            // Reset everything
            this.$emit("update:dialog", false);
            this.$refs.affiliationForm.reset();
        },
        async create(){
            try {
                this.loading = true;
                if(!this.$refs.affiliationForm.validate()){
                    return;
                }
                let response = await this.$store.dispatch("affiliation/create",this.affiliation);
            } catch (error) {
                this.$store.dispatch("app/showMessage",{
                    message:error.message,
                    color:"error"
                })
            }finally{
                this.loading = false;
                this.reset();
            }
        }
    }
}
</script>

<style>

</style>
